import { render, staticRenderFns } from "./projectRight.vue?vue&type=template&id=1c583e4d&scoped=true&"
import script from "./projectRight.vue?vue&type=script&lang=js&"
export * from "./projectRight.vue?vue&type=script&lang=js&"
import style0 from "./projectRight.vue?vue&type=style&index=0&id=1c583e4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c583e4d",
  null
  
)

export default component.exports